<template>
    <el-dialog
      :visible.sync="visible"
      width="900px"
      class="view-img-dialog"
      :close-on-click-modal="false"
      :show-close="false"
      center>
      <template slot="title">
          <div class="dialog-title">查看图片</div>
      </template>
      <div class="main-img-area">
        <img class="arrow-btn"  @click="prev"  :src=" currentIndex === 0? arrowLeftDisabled : arrowLeft" alt="">
        <div class="img-box">
          <!-- <img
            v-if="currentImg"
            :src="currentImg.url"
            :alt="currentImg.desc || ''"
            class="main-img"
          /> -->
          <el-image 
            class="main-img"
            v-if="currentImg"
            :src="currentImg.url" 
            :preview-src-list="[currentImg.url]">
          </el-image>
          <div class="img-desc" v-if="currentImg && currentImg.desc">
            {{ currentImg.desc }}
          </div>
        </div>
        <img class="arrow-btn"   @click="next"  :src=" currentIndex === list.length - 1? arrowRightDisabled : arrowRight" alt="">
      </div>
      <div class="thumb-list" ref="thumbList">
        <div
          v-for="(item, idx) in list"
          :key="idx"
          class="thumb-item"
          :class="{active: idx === currentIndex}"
          @click="goTo(idx)"
        >
          <img :src="item.url" :alt="item.desc || ''" />
        </div>
      </div>
      <div class="dialog-footer">
        <el-button type="primary" @click="close">关闭</el-button>
      </div>
    </el-dialog>
    
  </template>
  
  <script>
  import arrowRight from '../assets/images/dark/scoring/arrow-right.png'
  import arrowLeft from '../assets/images/dark/scoring/arrow-left.png'
  import arrowRightDisabled from '../assets/images/dark/scoring/arrow-right-disabled.png'
  import arrowLeftDisabled from '../assets/images/dark/scoring/arrow-left-disabled.png'
  export default {
    name: 'viewImgDialog',
    props: {
      list: {
        type: Array,
        default: () => []
      },
      visible: {
        type: Boolean,
        default: false
      },
      startIndex: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        currentIndex: this.startIndex,
        arrowRight,
        arrowLeft,
        arrowRightDisabled,
        arrowLeftDisabled
      }
    },
    computed: {
      currentImg() {
        return this.list[this.currentIndex] || null
      }
    },
    watch: {
      visible(val) {
        if (val) {
          this.currentIndex = this.startIndex
          this.$nextTick(this.scrollThumbToCurrent)
        }
      },
      startIndex(val) {
        this.currentIndex = val
        this.$nextTick(this.scrollThumbToCurrent)
      }
    },
    methods: {
      close() {
        this.$emit('update:visible', false)
      },
      prev() {
        if (this.currentIndex > 0) {
          this.currentIndex--
          this.scrollThumbToCurrent()
        }
      },
      next() {
        if (this.currentIndex < this.list.length - 1) {
          this.currentIndex++
          this.scrollThumbToCurrent()
        }
      },
      goTo(idx) {
        this.currentIndex = idx
        this.scrollThumbToCurrent()
      },
      scrollThumbToCurrent() {
        this.$nextTick(() => {
          const thumbList = this.$refs.thumbList
          const items = thumbList.querySelectorAll('.thumb-item')
          const current = items[this.currentIndex]
          if (current) {
            const listRect = thumbList.getBoundingClientRect()
            const itemRect = current.getBoundingClientRect()
            // 如果当前缩略图不在可视区域，则滚动
            if (itemRect.left < listRect.left) {
              thumbList.scrollLeft -= (listRect.left - itemRect.left + 8)
            } else if (itemRect.right > listRect.right) {
              thumbList.scrollLeft += (itemRect.right - listRect.right + 8)
            }
          }
        })
      }
    }
  }
  </script>
  
  <style scoped lang="scss">
@import '../assets/style/variables.scss';
@import '../assets/style/mixin.scss';
  .view-img-dialog .dialog-title {
    @include text-color(titleColor);
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 16px;
  }
  .main-img-area {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
    @include bg-color(dialogBg);
    padding-bottom: 16px;
  }
  .img-box {
    flex: 1;
    text-align: center;
  }
  .main-img {
    max-width: 600px;
    max-height: 500px;
    border-radius: 6px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  }
  .img-desc {
    @include text-color(titleColor);
    margin-top: 8px;
    font-size: 14px;
    text-align: center;
  }
  .arrow-btn {
    width: 20px;
    height: 20px;
    margin: 0 24px;
    cursor: pointer;
  }
  .thumb-list {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 16px;
    overflow-x: auto;
    overflow-y: hidden;
    // max-width: 90%;
    white-space: nowrap;
    padding-bottom: 4px;

    &::-webkit-scrollbar {
      height: 8px;
    }
    &::-webkit-scrollbar-thumb {
      background: #d3d3d3;
      border-radius: 4px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
  }
  .thumb-item {
    flex: 0 0 auto;
    width: 82px;
    height: 82px;
    margin: 0 4px;
    overflow: hidden;
    cursor: pointer;
    transition: border 0.2s;
    display: inline-block;
    border-radius: 6px;
    border: 1px solid #3D4049;
  }
  .thumb-item.active {
    border: 2px solid #409EFF;
  }
  .thumb-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .dialog-footer {
    text-align: center;
  }
  </style>